/**
 * ErrorDisplay 元件
 * 錯誤訊息顯示
 */

interface ErrorDisplayProps {
  error: Error | string;
  className?: string;
  onRetry?: () => void;
}

export function ErrorDisplay({
  error,
  className = '',
  onRetry,
}: ErrorDisplayProps) {
  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div
      className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-red-600 text-xl">⚠️</span>
          <div>
            <p className="text-red-800 font-semibold">載入失敗</p>
            <p className="text-red-600 text-sm mt-1">{errorMessage}</p>
          </div>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
          >
            重試
          </button>
        )}
      </div>
    </div>
  );
}
